import { z } from 'zod/v4';

export const TQLQueryGraphViewDTO = z.object({
  id: z.uuid(),
  name: z.string(),
  label: z.string(),
  updated_at: z.iso.datetime(),
  created_at: z.iso.datetime(),
  srm_search_query_id: z.uuid(),
  display_order: z.number(),
  configuration: z.record(z.string(), z.any()),
});
export type TQLQueryGraphView = z.infer<typeof TQLQueryGraphViewDTO>;

export const CreateTQLQueryGraphViewDTO = TQLQueryGraphViewDTO.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type CreateTQLQueryGraphView = z.infer<
  typeof CreateTQLQueryGraphViewDTO
>;

export const UpdateTQLQueryGraphViewDTO = TQLQueryGraphViewDTO.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type UpdateTQLQueryGraphView = z.infer<
  typeof UpdateTQLQueryGraphViewDTO
>;

export const TQLQueryGraphViewBriefDTO = TQLQueryGraphViewDTO.omit({
  configuration: true,
});
export type TQLQueryGraphViewBrief = z.infer<typeof TQLQueryGraphViewBriefDTO>;